'use client';
import type { SVGProps } from "react";
import type { FC } from 'react';
import type { IconProps } from '../utils/type';
import { SvgIconWrapper } from '../utils/svg-icon-wrapper';
/**
 * Auto-generated icon component: Do not change this component manually.
 * Config file: customSvgrTemplate.js
 */
const SvgBase: FC<IconProps> = (props: SVGProps<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" {...props}><path fill="currentColor" fillRule="evenodd" d="M1.983 2.808a1 1 0 0 0 0 1.414l2.606 2.606C3.218 8 2.058 9.492 1.189 11.208a1.75 1.75 0 0 0 0 1.584C3.374 17.106 7.398 20 12 20c1.661 0 3.248-.377 4.699-1.062l2.254 2.254a1 1 0 0 0 1.415-1.414L3.398 2.808a1 1 0 0 0-1.415 0m13.19 14.605-1.694-1.695a4 4 0 0 1-5.197-5.197L6.007 8.246c-1.179.98-2.197 2.25-2.976 3.754 1.923 3.712 5.298 6 8.969 6a8.9 8.9 0 0 0 3.174-.587m3.44-2.215A12.3 12.3 0 0 0 20.968 12C19.046 8.288 15.67 6 12 6c-.779 0-1.544.103-2.285.3L8.126 4.713A10.9 10.9 0 0 1 12 4c4.602 0 8.626 2.893 10.81 7.208a1.75 1.75 0 0 1 0 1.584 14.4 14.4 0 0 1-2.784 3.82z" clipRule="evenodd" /></svg>;
const IconVisibilityOff = ({
  $size,
  $color,
  className,
  ...rest
}: IconProps) => <SvgIconWrapper $size={$size} $color={$color} className={className}><SvgBase {...rest} /></SvgIconWrapper>;
export default IconVisibilityOff;